import { HTMLAttributes } from "react";
import { BlockTitle } from "@blocks/Blocks";
import { FeedAttachmentType } from "@pages/Keyword/utils/types";

type InfographicsProps = {
  /** Infographics data required to display in infographics section*/
  infographics: FeedAttachmentType;
} & Pick<HTMLAttributes<HTMLDivElement>, "className">;

/**
 * Infographics card that is displayed in INFOGRAPHICS section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12510&t=gu7daMrrZOGnQaxt-4
 */
const Infographics = ({
  infographics: { title, name, urlPath, image },
}: InfographicsProps): React.ReactElement => {
  if (!image || !urlPath) return <></>;

  return (
    <div
      className="mb-8 border-t border-gray-850 lg:border-t-0"
      data-testid="infographics-component"
    >
      <BlockTitle
        text={title}
        rootClassName="mb-4 mt-2 lg:mt-0 text-lg md:text-3xl"
      />

      <div className="flex gap-4">
        <img
          src={image.original.url}
          alt="infographics"
          className="w-1/4 md:w-2/5 lg:w-1/4"
          width={100}
          height={70}
        />

        <span className="inline-block w-3/4 font-lct text-base font-bold text-gray-850 md:w-3/5 md:text-lg lg:w-3/4">
          <a
            className="hover:underline"
            title={name}
            href={urlPath}
            target="_blank"
            rel="noreferrer"
          >
            {name}
          </a>
        </span>
      </div>
    </div>
  );
};

export default Infographics;
